import React from "react";
import { $accounts, $selectedAccountIdx } from "../../../common/accounts2";
import { ChargesListItem } from "../atoms/ChargesListItem";
import { useStore } from "effector-react";
import { empty } from "../../../common/functions";

import "../styles/Charges.css";
import "../styles/Bill.css";

interface IAccountBlock {
  lookButtonIsClicked: boolean;
  setLookButtonIsClicked: React.Dispatch<React.SetStateAction<boolean>>;
}

//отрисовываем список начислений
export const ChargesBlock = ({
  lookButtonIsClicked,
  setLookButtonIsClicked,
}: IAccountBlock) => {
  const [currentIndex, setCurrentIndex] = React.useState(3);
  const { accounts } = useStore($accounts);
  const accIdx = useStore($selectedAccountIdx);
  if (accIdx < 0 || empty(accounts))
    return (
      <div className="page__data-card">
        <p className="data-card__text">Начисления не найдены</p>
      </div>
    );
  let charges = accounts[accIdx].totalByMonth;
  if(empty(charges)) charges = []
  //charges = charges.sort((a, b) => a.billDate < b.billDate ? 1 : -1)
  let screenWidth = window.innerWidth;

  function showMorelCards() {
    setCurrentIndex(currentIndex + 3);
    
  }

  return (
    <div className="page__data-card">
      <h2 className="data-card__title">Начисления</h2>
      <ul className="charges__list">
        {charges.length !== 0 &&
          charges.slice(0, currentIndex)
            .map((charge, i) => (
              <ChargesListItem
                id={charge.id.toString()}
                key={i}
                last={i === 0 ? true : false}
                kopeiki={charge.monthAmount}
                periodName={charge.periodName}
                periodId={charge.periodId}
                screenWidth={screenWidth}
                accountId={accounts[accIdx].id}
                lookButtonIsClicked={lookButtonIsClicked}
                setLookButtonIsClicked={setLookButtonIsClicked}
              />
            ))}
        {currentIndex < charges.length && (
          <button
            type="button"
            onClick={showMorelCards}
            className="charges__button-more"
          >
            Загрузить ещё...
          </button>
        )}
      </ul>
    </div>
  );
};
